







import { Component, Mixins } from "vue-property-decorator";
import { DocumentEditableMixin, CommonComponentsAccessibleMixin } from "../../mixins";

@Component
export default class DocumentEditNavigator extends Mixins(DocumentEditableMixin, CommonComponentsAccessibleMixin) {
  getOperationName(isTemporary: boolean): string {
    return isTemporary ? "一時保存" : "登録";
  }

  async registerDocument(isTemporary: boolean = false): Promise<void> {
    try {
      if (isTemporary) {
        await this.commonComponents.operators.registerer.registerDocumentAsTemporary(true, true);
      } else {
        await this.commonComponents.operators.registerer.registerDocument(true);
      }
      this.$success(`${this.getOperationName(isTemporary)}成功`, `${this.getOperationName(isTemporary)}しました。`);
    } catch (e) {
      this.$error(`${this.getOperationName(isTemporary)}失敗`, `${this.getOperationName(isTemporary)}できませんでした。`, e);
    }
  }

  async registerDocumentAsTemporary(): Promise<void> {
    await this.commonComponents.operators.registerer.registerDocumentAsTemporary(true, true);
  }
}
